import FlashInput from "./flash_input";

export default FlashInput;
